import { useEffect, useState } from "react";

import { appThemeApiRef, useApi } from "@backstage/core-plugin-api";

/**
 * Detects whether the active Backstage theme is dark.
 *
 * Subscribes to the app theme API to reactively track theme changes.
 *
 * @returns An object with `isDark` — `true` when the active theme
 *   variant is `"dark"`.
 */
export function useThemeMode(): { isDark: boolean } {
    const themeApi = useApi(appThemeApiRef);
    const [themeId, setThemeId] = useState(() => themeApi.getActiveThemeId());

    useEffect(() => {
        const subscription = themeApi.activeThemeId$().subscribe({
            next: id => setThemeId(id),
        });
        return () => subscription.unsubscribe();
    }, [themeApi]);

    const themes = themeApi.getInstalledThemes();
    const active = themes.find(t => t.id === themeId);
    return { isDark: active?.variant === "dark" };
}
